import {DocumentChanges} from "../models/document-changes";
import {DocumentChangesDto} from "../dto/document-changes-dto";
import {RBCheck, RBConvert} from "@ldw/roesberg";

export class DocumentChangesFactory {
  static fromDTO(dtoList: DocumentChangesDto[]): DocumentChanges[] {
    const list: DocumentChanges[] = [];
    if (!RBCheck.isNullOrHasNoValues(dtoList)) {
      dtoList.forEach(dto => {
        const item = new DocumentChanges();
        item.action = dto.action;
        item.user = dto.user;
        item.dateTime = RBConvert.jsonUTCStringToString(dto.dateTime);
        list.push(item);
      })
    }
    return list;
  }
}
